import {useTranslation} from 'react-i18next';
import DescText from './DescText';
import {pAlert} from './PAlert';
import Text from './Text';
import ICON_HELP_LIGHT from '../../../public/static/ranking/icon-help-light.svg';
import ICON_HELP from '../../../public/static/ranking/icon-help.svg';
import useTheme from '../hook/useTheme';

interface IProps {
  lastModifiedDate: string;
}

export default function RankingCriteria({lastModifiedDate}: IProps) {
  const {isLightMode} = useTheme();
  const {t} = useTranslation();
  const handleClickHelpBtn = () => {
    pAlert({
      title: t('ranking_criteria_popup_title'),
      isTextAlignCenter: false,
      desc: () => <DescText>{t('ranking_criteria_popup_contents')}</DescText>,
    });
  };

  return (
    <div
      className="flex items-center h-14 absolute right-5 top-8 z-10"
      onClick={handleClickHelpBtn}
    >
      <Text className="s12-regular-grey06 leading-14 pt-2">
        {lastModifiedDate}
      </Text>
      <div className="flex items-center h-14 ml-4">
        <img
          src={isLightMode ? ICON_HELP_LIGHT : ICON_HELP}
          alt=""
          width={12}
          height={12}
        />
      </div>
    </div>
  );
}
